var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("header-programa", {
                    attrs: { programa: _vm.solicitud?.programa },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-overlay",
            { attrs: { show: false } },
            [
              _c(
                "b-row",
                [
                  _c("b-col", { staticClass: "mt-3 mb-3" }, [
                    _c("h4", [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t(
                              "apeironGwApp.actividadesRetribucion.mensajes.alcance"
                            )
                          ),
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("hr", { staticClass: "linea-horizontal-roja" }),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.actividadesRetribucion.campos.numeroActividadesRealizadas"
                              ) + "*:",
                            "label-for": "form-numero-actividades-realizadas",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "form-numero-actividades-realizadas",
                              disabled: !_vm.esEscritura,
                              type: "number",
                            },
                            model: {
                              value: _vm.indicadoresForm.numeroActividades,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.indicadoresForm,
                                  "numeroActividades",
                                  _vm._n($$v)
                                )
                              },
                              expression: "indicadoresForm.numeroActividades",
                            },
                          }),
                          _vm._v(" "),
                          !_vm.$v.indicadoresForm.numeroActividades.required
                            ? _c("small", {
                                staticClass: "text-danger",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.required")
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.actividadesRetribucion.campos.horasDedicadasActividades"
                              ) + "*:",
                            "label-for": "form-horas-dedicadas",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "form-horas-dedicadas",
                              disabled: !_vm.esEscritura,
                              type: "number",
                            },
                            model: {
                              value: _vm.indicadoresForm.horasDedicadas,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.indicadoresForm,
                                  "horasDedicadas",
                                  _vm._n($$v)
                                )
                              },
                              expression: "indicadoresForm.horasDedicadas",
                            },
                          }),
                          _vm._v(" "),
                          !_vm.$v.indicadoresForm.horasDedicadas.required
                            ? _c("small", {
                                staticClass: "text-danger",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.required")
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.actividadesRetribucion.campos.institucionesParticipantes"
                              ) + "*:",
                            "label-for": "form-instituciones-participantes",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "form-instituciones-participantes",
                              disabled: !_vm.esEscritura,
                              type: "number",
                            },
                            model: {
                              value:
                                _vm.indicadoresForm.institucionesParticipantes,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.indicadoresForm,
                                  "institucionesParticipantes",
                                  _vm._n($$v)
                                )
                              },
                              expression:
                                "indicadoresForm.institucionesParticipantes",
                            },
                          }),
                          _vm._v(" "),
                          !_vm.$v.indicadoresForm.institucionesParticipantes
                            .required
                            ? _c("small", {
                                staticClass: "text-danger",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.required")
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.actividadesRetribucion.campos.comunidadesAtendidas"
                              ) + "*:",
                            "label-for": "form-comunidades-atendidas",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "form-comunidades-atendidas",
                              disabled: !_vm.esEscritura,
                              type: "number",
                            },
                            model: {
                              value: _vm.indicadoresForm.comunidadesAtendidas,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.indicadoresForm,
                                  "comunidadesAtendidas",
                                  _vm._n($$v)
                                )
                              },
                              expression:
                                "indicadoresForm.comunidadesAtendidas",
                            },
                          }),
                          _vm._v(" "),
                          !_vm.$v.indicadoresForm.comunidadesAtendidas.required
                            ? _c("small", {
                                staticClass: "text-danger",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.required")
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "md",
                            label:
                              _vm.$t(
                                "apeironGwApp.actividadesRetribucion.campos.impactoPercibido"
                              ) + " *",
                            "label-for": "form-impacto-percibido",
                          },
                        },
                        [
                          _c("b-form-textarea", {
                            attrs: {
                              name: "form-impacto-percibido",
                              rows: "4",
                              disabled: !_vm.esEscritura,
                            },
                            model: {
                              value: _vm.indicadoresForm.impactoPercibido,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.indicadoresForm,
                                  "impactoPercibido",
                                  $$v
                                )
                              },
                              expression: "indicadoresForm.impactoPercibido",
                            },
                          }),
                          _vm._v(" "),
                          !_vm.$v.indicadoresForm.impactoPercibido.required
                            ? _c("small", {
                                staticClass: "text-danger",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.required")
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("b-form-group", {
                        attrs: {
                          label: _vm.$t(
                            "apeironGwApp.actividadesRetribucion.campos.contribucionActividad"
                          ),
                          "label-for": "form-contribucion",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ ariaDescribedby }) {
                              return [
                                _c("b-form-checkbox-group", {
                                  attrs: {
                                    options: _vm.opcionesContribuciones,
                                    "aria-describedby": ariaDescribedby,
                                    name: "form-contribucion",
                                    disabled: !_vm.esEscritura,
                                  },
                                  model: {
                                    value: _vm.indicadoresForm.contribuciones,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.indicadoresForm,
                                        "contribuciones",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "indicadoresForm.contribuciones",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "8" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.actividadesRetribucion.campos.otraContribucion"
                              ) + ":",
                            "label-for": "form-otra-contribucion",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "form-otra-contribucion",
                              disabled: !_vm.esEscritura,
                            },
                            model: {
                              value: _vm.indicadoresForm.otraContribucion,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.indicadoresForm,
                                  "otraContribucion",
                                  $$v
                                )
                              },
                              expression: "indicadoresForm.otraContribucion",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "md",
                            label:
                              _vm.$t(
                                "apeironGwApp.actividadesRetribucion.campos.resultadosObservables"
                              ) + " *",
                            "label-for": "form-resultados-observables",
                          },
                        },
                        [
                          _c("b-form-textarea", {
                            attrs: {
                              name: "form-resultados-observables",
                              disabled: !_vm.esEscritura,
                              rows: "4",
                            },
                            model: {
                              value: _vm.indicadoresForm.resultadosObservables,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.indicadoresForm,
                                  "resultadosObservables",
                                  $$v
                                )
                              },
                              expression:
                                "indicadoresForm.resultadosObservables",
                            },
                          }),
                          _vm._v(" "),
                          !_vm.$v.indicadoresForm.resultadosObservables.required
                            ? _c("small", {
                                staticClass: "text-danger",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.required")
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("b-form-group", {
                        attrs: {
                          label:
                            _vm.$t(
                              "apeironGwApp.actividadesRetribucion.campos.experienciaReplicable"
                            ) + " *",
                          "label-for": "form-replicable",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ ariaDescribedby }) {
                              return [
                                _c("b-form-radio-group", {
                                  attrs: {
                                    options: _vm.opcionesReplicable,
                                    "aria-describedby": ariaDescribedby,
                                    name: "form-replicable",
                                  },
                                  model: {
                                    value: _vm.indicadoresForm.puedeReplicarse,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.indicadoresForm,
                                        "puedeReplicarse",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "indicadoresForm.puedeReplicarse",
                                  },
                                }),
                                _vm._v(" "),
                                !_vm.$v.indicadoresForm.puedeReplicarse.required
                                  ? _c("small", {
                                      staticClass: "text-danger",
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.$t("entity.validation.required")
                                        ),
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "md",
                            label: _vm.$t(
                              "apeironGwApp.actividadesRetribucion.campos.explique"
                            ),
                            "label-for": "form-replicable-explique",
                          },
                        },
                        [
                          _c("b-form-textarea", {
                            attrs: {
                              name: "form-replicable-explique",
                              rows: "4",
                              disabled: !_vm.esEscritura,
                            },
                            model: {
                              value: _vm.indicadoresForm.puedeReplicarseDesc,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.indicadoresForm,
                                  "puedeReplicarseDesc",
                                  $$v
                                )
                              },
                              expression: "indicadoresForm.puedeReplicarseDesc",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.esReadOnly
                ? _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _vm.esEscritura
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-lg btn-block",
                                attrs: {
                                  type: "button",
                                  disabled: _vm.desactivarBoton,
                                },
                                on: { click: _vm.guardarIndicadores },
                              },
                              [
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t(
                                        "apeironGwApp.actividadesRetribucion.acciones.guardarSeccion"
                                      )
                                    ),
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }